<article class="glassmorphism table-card" (mouseenter)="handleHover(true)" (mouseleave)="handleHover(false)">
  <hgroup>
    <h2 class="card-title">{{ link.table1 }} - {{ link.table2 }}</h2>
    <button type="button" (click)="deleteLink()">
      <span class="outside-window">Effacer le lien</span>
      <svg-trash></svg-trash>
    </button>
  </hgroup>
  {{ link.computeTranslatedSentence(isEnglish) }}
</article>
